module.exports = __webpack_public_path__ + "static/media/prop-11@2x.33238a54.webp";